/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteExtractSchemaRequest = {
  schemaId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DeleteExtractSchemaRequest$inboundSchema: z.ZodType<
  DeleteExtractSchemaRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  schema_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "schema_id": "schemaId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteExtractSchemaRequest$Outbound = {
  schema_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteExtractSchemaRequest$outboundSchema: z.ZodType<
  DeleteExtractSchemaRequest$Outbound,
  z.ZodTypeDef,
  DeleteExtractSchemaRequest
> = z.object({
  schemaId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    schemaId: "schema_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteExtractSchemaRequestToJSON(
  deleteExtractSchemaRequest: DeleteExtractSchemaRequest,
): string {
  return JSON.stringify(
    DeleteExtractSchemaRequest$outboundSchema.parse(deleteExtractSchemaRequest),
  );
}
export function deleteExtractSchemaRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteExtractSchemaRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteExtractSchemaRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteExtractSchemaRequest' from JSON`,
  );
}
